import React, { useState } from 'react';
import { updateCpfByEmail } from '../../Api';

// Modal "CPF não cadastrado" em CSS puro (sem MUI). Mesma API:
// <ModalAtualizarCpf open email onCpfAtualizado />.
export default function ModalAtualizarCpf({ open, email, onCpfAtualizado }) {
    const [cpfInput, setCpfInput] = useState('');
    const [sucesso, setSucesso] = useState(false);

    const handleSalvarCpf = async () => {
        const cpfLimpo = cpfInput.replace(/\D/g, '');

        if (cpfLimpo.length !== 11) {
            alert("CPF inválido. Digite exatamente 11 números.");
            return;
        }

        try {
            await updateCpfByEmail({ email, cpf: cpfLimpo });
            setSucesso(true);
            setTimeout(() => {
                onCpfAtualizado(cpfLimpo); // fecha modal e atualiza CPF no componente pai
            }, 1500);
        } catch (err) {
            console.error("Erro ao salvar CPF:", err);
            alert(
                "Não foi possível salvar seu CPF em nosso sistema. " +
                "Para gerar sua carteira, por favor, informe corretamente o número do seu CPF. " +
                "Caso o problema persista, entre em contato com a equipe da FUNEMG."
            );
        }
    };

    if (!open) return null;

    return (
        <div style={S.overlay}>
            <div style={S.box} role="dialog" aria-modal="true">
                <h2 style={S.title}>CPF não cadastrado</h2>
                <p style={S.text}>
                    Para gerar corretamente seus dados, por favor, informe seu CPF corretamente.
                    Se precisar de ajuda, fale com a equipe da FUNEMG.
                </p>

                <label style={S.label}>
                    CPF
                    <input
                        style={S.input}
                        value={cpfInput}
                        onChange={(e) => setCpfInput(e.target.value.replace(/\D/g, ''))}
                        maxLength={11}
                        inputMode="numeric"
                        placeholder="Apenas números (11 dígitos)"
                    />
                </label>
                <span style={S.helper}>Apenas números (11 dígitos)</span>

                <button style={S.btn} onClick={handleSalvarCpf}>Salvar CPF</button>

                {sucesso && (
                    <div style={S.sucesso}>CPF atualizado com sucesso!</div>
                )}
            </div>
        </div>
    );
}

const S = {
    overlay: {
        position: 'fixed', inset: 0, zIndex: 1300,
        background: 'rgba(10,10,14,0.5)', backdropFilter: 'blur(2px)',
        display: 'grid', placeItems: 'center', padding: 16,
        fontFamily: "'Inter', sans-serif",
    },
    box: {
        width: '100%', maxWidth: 400, background: '#fff',
        borderRadius: 16, boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
        padding: 28, display: 'flex', flexDirection: 'column', gap: 14,
    },
    title: { margin: 0, fontSize: 19, fontWeight: 800, color: '#16161a' },
    text: { margin: 0, fontSize: 14, lineHeight: 1.55, color: '#64748b' },
    label: { display: 'flex', flexDirection: 'column', gap: 6, fontSize: 13, fontWeight: 700, color: '#27272e' },
    input: {
        marginTop: 2, padding: '11px 12px', fontSize: 15,
        border: '1px solid #d8d8cf', borderRadius: 10, outline: 'none',
        width: '100%', boxSizing: 'border-box',
    },
    helper: { fontSize: 12, color: '#8a8a80', marginTop: -8 },
    btn: {
        marginTop: 4, padding: '12px 16px', fontSize: 15, fontWeight: 800,
        color: '#16161a', background: 'linear-gradient(135deg,#e2e144,#d2d122)',
        border: 'none', borderRadius: 10, cursor: 'pointer',
    },
    sucesso: { color: '#16794a', fontWeight: 700, fontSize: 14 },
};
